import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from './lang/en';
import ja from './lang/ja';
import ko from './lang/ko';
import zh from './lang/zh';
import zt from './lang/zt';

const DEFAULT_LOCALE = 'ja';
export const LOCALE_LIST = ['en', 'ja', 'ko', 'zh', 'zt'];

const resources = {
  en: { translation: en },
  ja: { translation: ja },
  ko: { translation: ko },
  zh: { translation: zh },
  zt: { translation: zt }
};

const requestedLocale = new URLSearchParams(location.search)
  .get('lang')
  ?.toLowerCase();
const initialLocale =
  (requestedLocale && LOCALE_LIST.includes(requestedLocale)
    ? requestedLocale
    : undefined) ??
  localStorage.getItem('locale') ??
  DEFAULT_LOCALE;

void i18n.use(initReactI18next).init({
  lng: initialLocale,
  fallbackLng: DEFAULT_LOCALE,
  returnNull: false,
  resources
});

document.documentElement.setAttribute('lang', initialLocale);

export default i18n;
